<div class="quote-preview-root">
<!--
  Staff preview is moved to document.body in preview.vue (mounted).
  Quote builder mounts this under .sticky.sidebar; list view does not —
  without a body portal, position:fixed / Safari fill behave differently.
-->
<transition :name="public_accept ? '' : 'modal'">
  <div :class="public_accept ? 'document-preview-public-page document-preview-modal' : 'modal-mask document-preview-modal'">
    <div v-if="!public_accept" class="modal-safari-bleed" aria-hidden="true"></div>
    <div v-if="!public_accept" class="modal-safari-tint" aria-hidden="true"></div>
    <div :class="public_accept ? 'document-preview-public-inner' : 'modal-wrapper'">
      <div :class="public_accept ? '' : 'modal-container'">
        <div class="document-preview-shell">
          <div class="document-preview-chrome modal-header" v-if="!public_accept">
            <segment-control
              v-if="showOptionSegments"
              class="quote-option-segments"
              :model-value="activeOptionIndex"
              :options="optionSegmentOptions"
              @update:model-value="onOptionSegmentChange"
            ></segment-control>
            <button type="button" class="document-preview-close" v-on:click="requestClose">
              <img src="../../../../assets/img/icn_close.svg" alt="" class="document-preview-close-icon" aria-hidden="true">
              <span>Close</span>
            </button>
          </div>
          <div class="document-preview-public-options" v-if="public_accept && showOptionSegments">
            <segment-control
              class="quote-option-segments"
              :model-value="activeOptionIndex"
              :options="optionSegmentOptions"
              @update:model-value="onOptionSegmentChange"
            ></segment-control>
          </div>

          <div class="document-preview-body">
          <div class="document-preview-content">
            <div class="document-preview-logo-row">
              <h1 class="document-preview-doctitle">{{ documentTitle }}</h1>
              <div class="document-preview-logo" aria-label="Logo">
                <img
                  v-if="settings && settings.images && settings.images.length"
                  :src="getImageUrl({ images: settings.images })"
                  alt="Company logo"
                  class="document-preview-logo-img">
              </div>
            </div>

            <div class="document-preview-header-info">
              <div class="document-preview-to">
                <div class="to-label">To:</div>
                <div class="to-name">{{ displayCompany }}</div>
                <div class="to-address" v-if="displayAddressLines && displayAddressLines.length">
                  <div v-for="(line, idx) in displayAddressLines" :key="idx">{{ line }}</div>
                </div>
              </div>

              <div class="document-preview-company-details">
                <div class="company-name">{{ settings && settings.business_name ? settings.business_name : '' }}</div>
                <div class="company-line">{{ settings && settings.address && settings.address.address_line_1 ? settings.address.address_line_1 : '' }}</div>
                <div class="company-line">{{ companySuburbStateLine }}</div>
                <div class="company-field" v-if="settings && settings.phone">Phone: {{ settings.phone }}</div>
                <div class="company-field" v-if="settings && settings.abn">ABN: {{ settings.abn }}</div>
                <div class="company-field" v-if="settings && settings.licence_no">Licence No: {{ settings.licence_no }}</div>
              </div>
            </div>

            <div class="document-preview-meta">
              <div class="meta-item">
                <span class="meta-label">{{ documentNumberLabel }}</span>
                <span class="meta-value meta-number">{{ quote.number || '—' }}</span>
              </div>
              <div class="meta-item" v-if="quote.service_m8_job_number != null && quote.service_m8_job_number !== ''">
                <span class="meta-label">SM8 Job #</span>
                <span class="meta-value">
                  <img src="../../../../assets/img/icn_servicem8.png" style="height:14px;vertical-align:middle;margin-right:3px;">{{ quote.service_m8_job_number }}
                </span>
              </div>
              <div class="meta-item">
                <span class="meta-label">Issued</span>
                <input v-if="canEditMetaFields" type="date" class="meta-value meta-date-issued preview-editable" v-model="date">
                <span v-else class="meta-value meta-date-issued">{{ formatDisplayDate(date) }}</span>
              </div>
              <div class="meta-item">
                <span class="meta-label">{{ dueDateLabel }}</span>
                <input v-if="canEditMetaFields" type="date" class="meta-value meta-date-expiry preview-editable" v-model="dueDate">
                <span v-else class="meta-value meta-date-expiry">{{ formatDisplayDate(dueDate) }}</span>
              </div>
              <div class="meta-item meta-item-reference-row">
                <span class="meta-label">Reference</span>
                <input v-if="canEditMetaFields" type="text" class="meta-value meta-reference preview-editable" v-model="quote.reference" placeholder="Reference">
                <span v-else class="meta-value meta-reference">{{ previewReferenceDisplay }}</span>
              </div>
            </div>

            <table class="document-preview-table">
              <thead>
                <tr>
                  <th>Items</th>
                  <th class="col-qty">Qty</th>
                  <th class="col-unit">Unit Price</th>
                  <th class="col-total">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in allItems" :key="idx" class="top aligned">
                  <td>
                    <div class="item-title">{{ item.title }}</div>
                    <div class="item-description" v-if="lineItemDescription(item)">{{ lineItemDescription(item) }}</div>
                  </td>
                  <td class="col-qty">{{ parseInt(item.qty != null ? item.qty : 0, 10) }}</td>
                  <td class="col-unit">{{ currency(getUnitPrice(item), '$', 2) }}</td>
                  <td class="col-total">{{ currency(getLineTotal(item), '$', 2) }}</td>
                </tr>
                <tr v-if="hasAppliedDiscount" class="top aligned document-preview-discount-table-row">
                  <td>
                    <div class="item-title">Discount: {{ quote.discount_title || '—' }}</div>
                    <div class="item-description" v-if="quote.discount_description">{{ quote.discount_description }}</div>
                  </td>
                  <td class="col-qty"></td>
                  <td class="col-unit"></td>
                  <td class="col-total">{{ currency(discountDisplayNegative, '$', 2) }}</td>
                </tr>
              </tbody>
            </table>

            <div class="document-preview-summary">
              <div class="document-preview-totals-wrap">
                <div class="document-preview-totals-left" v-if="canEditMetaFields">
                  <button type="button" class="quote-set-discount-button" @click="openDiscountModal">Set discount</button>
                </div>
                <div class="document-preview-totals-right">
                  <div class="summary-row">
                    <span class="summary-label">Subtotal</span>
                    <span class="summary-value">{{ currency(quote.sub_total, '$', 2) }}</span>
                  </div>
                  <div class="summary-row">
                    <span class="summary-label">GST</span>
                    <span class="summary-value">{{ currency(quote.gst_total, '$', 2) }}</span>
                  </div>
                  <div class="summary-row summary-total">
                    <span class="summary-label">TOTAL</span>
                    <span class="summary-value">{{ currency(quote.total, '$', 2) }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="document-preview-terms">
              <div class="terms-label">Terms and Conditions</div>
              <textarea v-if="canEditMetaFields" class="terms-content preview-editable" rows="3" v-model="quote.terms" placeholder="Thank you for your enquiry..."></textarea>
              <div v-else class="terms-content terms-readonly">{{ quote.terms || '—' }}</div>
            </div>

            <div class="document-preview-signature" :class="{ 'is-unsigned': !signatureImage }">
              <img v-if="signatureImage" :src="signatureImage" class="signature-image" alt="">
              <div class="signature-baseline" aria-hidden="true"></div>
              <p v-if="signatureImage" class="signature-caption">
                Signed and {{ signatureCaptionVerb }} by {{ signedByValue }}, {{ formatSignedAt(signedAtValue) }}
              </p>
              <p v-else class="signature-placeholder-label">Customer signature</p>
            </div>
          </div>

          <div class="document-preview-actions document-preview-customer-cta" v-if="public_accept && showCustomerCta">
            <div class="customer-accept-panel">
              <h3 class="customer-accept-heading">{{ customerCtaTitle }}</h3>
              <ol class="customer-accept-steps">
                <li v-for="(step, idx) in customerCtaSteps" :key="'cta-step-' + idx">{{ step }}</li>
              </ol>
              <button type="button" class="ui primary button fluid customer-accept-button" @click="openSignatureModalForCustomer">{{ customerCtaButtonLabel }}</button>
            </div>
          </div>

          <div class="document-preview-actions" v-else-if="!public_accept">
            <div class="status-dropdown">
              <label>Status</label>
              <app-select
                :key="'status-select-' + statusSelectKey"
                :items="statusSelectItems"
                :value="statusSelectValue"
                :disabled="!canEditStatus"
                @selected="onStatusSelected">
              </app-select>
            </div>
            <button type="button" class="action-btn negative" v-if="quote.number" v-on:click="deleteQuote">
              <img src="../../../../assets/img/icn_trash.svg" alt="" class="action-icon" aria-hidden="true">
              <span class="action-label">Delete</span>
            </button>
            <button type="button" class="action-btn" v-on:click="requestDuplicate">
              <img src="../../../../assets/img/icn_file.svg" alt="" class="action-icon" aria-hidden="true">
              <span class="action-label">Duplicate</span>
            </button>
            <button type="button" class="action-btn" v-on:click="gotoQuote">
              <img src="../../../../assets/img/icn_edit.svg" alt="" class="action-icon" aria-hidden="true">
              <span class="action-label">Edit</span>
            </button>
            <button type="button" class="action-btn" v-bind:class="{loading:saving, disabled:saving}" v-on:click="onSaveClick">
              <img src="../../../../assets/img/icn_box.svg" alt="" class="action-icon" aria-hidden="true">
              <span class="action-label">Save</span>
            </button>
            <button type="button" class="action-btn primary-green" v-on:click="onSendClick">
              <img src="../../../../assets/img/icn_envelope.svg" alt="" class="action-icon" aria-hidden="true">
              <span class="action-label">Send</span>
            </button>
            <button type="button" class="action-btn primary-blue" v-on:click="convertToInvoice">
              <img src="../../../../assets/img/icn_dollar.svg" alt="" class="action-icon" aria-hidden="true">
              <span class="action-label">Invoice</span>
            </button>
          </div>
          </div>

        <div class="modal-footer document-preview-footer-mobile document-preview-customer-cta-mobile" v-if="public_accept && showCustomerCta">
          <div class="customer-accept-panel">
            <h3 class="customer-accept-heading">{{ customerCtaTitle }}</h3>
            <ol class="customer-accept-steps">
              <li v-for="(step, idx) in customerCtaSteps" :key="'cta-mobile-step-' + idx">{{ step }}</li>
            </ol>
            <button type="button" class="ui primary button fluid customer-accept-button" @click="openSignatureModalForCustomer">{{ customerCtaButtonLabel }}</button>
          </div>
        </div>

        <div class="modal-footer document-preview-footer-mobile" v-else-if="!public_accept">
          <div class="status-dropdown footer-status">
            <label>Status</label>
            <app-select
              :key="'status-select-mobile-' + statusSelectKey"
              :items="statusSelectItems"
              :value="statusSelectValue"
              :disabled="!canEditStatus"
              @selected="onStatusSelected">
            </app-select>
          </div>
          <button type="button" class="action-btn negative" v-if="quote.number" v-on:click="deleteQuote">
            <img src="../../../../assets/img/icn_trash.svg" alt="" class="action-icon" aria-hidden="true">
            <span class="action-label">Delete</span>
          </button>
          <button type="button" class="action-btn" v-on:click="requestDuplicate">
            <img src="../../../../assets/img/icn_file.svg" alt="" class="action-icon" aria-hidden="true">
            <span class="action-label">Duplicate</span>
          </button>
          <button type="button" class="action-btn" v-on:click="gotoQuote">
            <img src="../../../../assets/img/icn_edit.svg" alt="" class="action-icon" aria-hidden="true">
            <span class="action-label">Edit</span>
          </button>
          <button type="button" class="action-btn" v-bind:class="{loading:saving, disabled:saving}" v-on:click="onSaveClick">
            <img src="../../../../assets/img/icn_box.svg" alt="" class="action-icon" aria-hidden="true">
            <span class="action-label">Save</span>
          </button>
          <button type="button" class="action-btn primary-green" v-on:click="onSendClick">
            <img src="../../../../assets/img/icn_envelope.svg" alt="" class="action-icon" aria-hidden="true">
            <span class="action-label">Send</span>
          </button>
          <button type="button" class="action-btn primary-blue" v-on:click="convertToInvoice">
            <img src="../../../../assets/img/icn_dollar.svg" alt="" class="action-icon" aria-hidden="true">
            <span class="action-label">Invoice</span>
          </button>
        </div>
        </div>
      </div>
    </div>
    <app-standard-modal
      :open="discountModalVisible"
      title="Set Discount"
      title-id="quote-set-discount-title"
      size="small"
      @close="discountModalVisible = false"
    >
      <app-field-label>Discount type</app-field-label>
      <div class="quote-discount-tabs">
        <button type="button" class="quote-discount-tab" :class="{active: discountTab === 'list'}" @click="discountTab='list'">Select from list</button>
        <button type="button" class="quote-discount-tab" :class="{active: discountTab === 'amount'}" @click="discountTab='amount'">Enter Amount</button>
      </div>
      <div v-if="discountTab === 'list'" class="quote-discount-list">
        <div
          v-for="discount in discounts"
          :key="discount.id"
          @click="toggleDiscount(discount)"
          class="quote-discount-item"
          :class="{active: selectedDiscountId != null && String(selectedDiscountId) === String(discount.id)}">
          <div class="quote-discount-item-row">
            <div class="quote-discount-item-pill">
              {{ discount.type === 'percentage' ? `${Number(discount.amount || 0)}% OFF` : `$${Number(discount.amount || 0)} OFF` }}
            </div>
            <div class="quote-discount-item-description">{{ discount.description || discount.title }}</div>
          </div>
        </div>
      </div>
      <div v-else class="quote-discount-amount-pane">
        <app-field-label>Discount</app-field-label>
        <div class="ui left labeled input fluid">
          <label class="ui label">$</label>
          <input type="number" step="0.01" min="0" v-model="adhocDiscountAmount" placeholder="0.00">
        </div>
        <div class="quote-discount-hint">This will overwrite pre-selected discounts</div>
      </div>
      <template #footer>
        <button type="button" class="ui basic button smardie-btn-secondary" @click="discountModalVisible=false">Cancel</button>
        <button type="button" class="ui primary button" @click="applyDiscountSelection">Apply</button>
      </template>
    </app-standard-modal>
  </div>
</transition>
<signature-accept-modal
  ref="signatureModal"
  :visible="signatureModalVisible"
  :customer-name="signatureCustomerName"
  :disclaimer="signatureDisclaimer"
  :can-submit="canSubmitSignature"
  :submitting="signatureSubmitting"
  :option-select-items="optionAcceptSelectItems"
  :selected-option-id="selectedAcceptOptionId"
  @update:customerName="signatureCustomerName = $event"
  @update:signatureData="signatureData = $event"
  @update:hasSignature="hasSignature = $event"
  @update:selectedOptionId="onAcceptOptionSelected"
  @cancel="cancelSignatureModal"
  @submit="submitSignature">
</signature-accept-modal>
</div>
